// extracted by mini-css-extract-plugin
export default {"container":"ValueColumn_container__3ieEH","noAccess":"ValueColumn_noAccess__WhtnP"};